export const IMPROVEMENT_IDEA_SOURCE = 'ImprovementIdea'
export const IMPROVEMENT_IDEA_TABLE_NAME = 'IMPROVEMENT_IDEA_LIST'
export const IMPROVEMENT_IDEA_ORIGIN = 'improvement-ideas'

const OPEN_TYPE = 0
const ACCEPTED = 1
const REJECTED = 2
const CLOSED = 3
export const IMPROVEMENT_IDEAS_STATUS = Object.freeze({
  open: OPEN_TYPE,
  accepted: ACCEPTED,
  rejected: REJECTED,
  closed: CLOSED,
})

export const TRANSVERSALIZABLE_TYPES = Object.freeze([
  { value: 0, text: 'improvement_idea.messages.not_transversalizable' },
  { value: 1, text: 'improvement_idea.messages.transversalizable_inside' },
  { value: 2, text: 'improvement_idea.messages.transversalizable_outside' },
])

export const TRANSVERSALIZABLE_TYPE_FOR_LINKED = 1

export const IMPROVEMENT_IDEAS_STATUS_TYPES = Object.freeze([
  { value: OPEN_TYPE, text: 'improvement_idea.messages.open' },
  { value: ACCEPTED, text: 'improvement_idea.messages.accepted' },
  { value: REJECTED, text: 'improvement_idea.messages.reject' },
  { value: CLOSED, text: 'improvement_idea.messages.closed' },
])
